import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Tab } from '../../internal/Tab';
import { clsx } from 'clsx';
import * as styles from './TabsList.module.css';
import { useDeviceType } from '../../../responsive';
import { COUNTER_MAX_LENGTH_DEFAULT, LABEL_COLORS_DEFAULT, SIZE_BY_DEVICE_TYPE, TEST_ID } from '../../constants';
import { useActiveIndicatorChange } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var TabsList = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var items = _ref.items,
    animated = _ref.animated,
    activeTabIndex = _ref.activeTabIndex,
    _ref$labelColors = _ref.labelColors,
    labelColors = _ref$labelColors === void 0 ? LABEL_COLORS_DEFAULT : _ref$labelColors,
    counterType = _ref.counterType,
    _ref$counterMaxLength = _ref.counterMaxLength,
    counterMaxLength = _ref$counterMaxLength === void 0 ? COUNTER_MAX_LENGTH_DEFAULT : _ref$counterMaxLength,
    rightItem = _ref.rightItem,
    size = _ref.size,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? TEST_ID : _ref$dataTestId,
    onTabClick = _ref.onTabClick;
  var deviceType = useDeviceType();
  useActiveIndicatorChange({
    containerRef: ref,
    activeTabIndex: activeTabIndex
  });
  var handleTabClick = React.useCallback(function (event, index) {
    event.currentTarget.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
    onTabClick(index);
  }, [onTabClick]);
  var handleKeyDown = React.useCallback(function (event, index) {
    if (event.code === 'Space') {
      handleTabClick(event, index);
    }
  }, [handleTabClick]);
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles['tabs'], _defineProperty({}, styles['tabs--animated'], animated)),
    ref: ref,
    "data-testid": dataTestId,
    children: items.map(function (tab, index) {
      return /*#__PURE__*/_jsx(Tab, _objectSpread(_objectSpread({}, tab), {}, {
        labelColors: tab.labelColors || labelColors,
        counterType: tab.counterType || counterType,
        isActive: activeTabIndex === index,
        size: size || SIZE_BY_DEVICE_TYPE[deviceType],
        rightItem: tab.rightItem || rightItem,
        counterMaxLength: counterMaxLength,
        onClick: function onClick(e) {
          return handleTabClick(e, index);
        },
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, index);
        }
      }), index);
    })
  });
});
TabsList.displayName = 'TabsList';